import { render, staticRenderFns } from "./PlatformsItems.vue?vue&type=template&id=931fa81c&scoped=true&"
import script from "./PlatformsItems.vue?vue&type=script&lang=js&"
export * from "./PlatformsItems.vue?vue&type=script&lang=js&"
import style0 from "./PlatformsItems.vue?vue&type=style&index=0&id=931fa81c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931fa81c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('931fa81c')) {
      api.createRecord('931fa81c', component.options)
    } else {
      api.reload('931fa81c', component.options)
    }
    module.hot.accept("./PlatformsItems.vue?vue&type=template&id=931fa81c&scoped=true&", function () {
      api.rerender('931fa81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/tusk/modules/components/pages/parts/target/PlatformsItems.vue"
export default component.exports